var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "eval-check-person-range" }, [
    _c("section", { staticClass: "yxt-upload-explain__section" }, [
      _c("ul", { staticClass: "yxt-upload-explain-list" }, [
        _c("li", [
          _c("span", { staticClass: "yxt-upload-explain-num color-gray-8" }, [
            _vm._v("1"),
          ]),
          _c(
            "div",
            {
              staticClass:
                "standard-size-14 color-gray-10 yxt-upload-explain-title",
            },
            [
              _vm._v(
                "\n          " +
                  _vm._s(_vm.$t("pc_gwnl_eval_selectedModel_title")) +
                  "\n          "
              ),
            ]
          ),
          _c(
            "div",
            { staticClass: "yxt-upload-explain-summary color-gray-8" },
            [_vm._v("\n          " + _vm._s(_vm.peopleName) + "\n        ")]
          ),
        ]),
        _c(
          "li",
          [
            _c("span", { staticClass: "yxt-upload-explain-num color-gray-8" }, [
              _vm._v("2"),
            ]),
            _c(
              "div",
              {
                staticClass:
                  "standard-size-14 color-gray-10 yxt-upload-explain-title",
              },
              [
                _vm._v(
                  "\n          " +
                    _vm._s(
                      _vm.$t("pc_gwnl_eval_selectedModel_downloadTemplate_tips")
                    ) +
                    "\n          "
                ),
              ]
            ),
            _c(
              "div",
              { staticClass: "yxt-upload-explain-summary color-gray-8" },
              [
                _c("span", { staticClass: "color-red-6" }, [
                  _vm._v(_vm._s(_vm.$t("pc_gwnl_import_readInstructions"))),
                ]),
                _vm._v(
                  "\n          " +
                    _vm._s(_vm.$t("pc_gwnl_import_fillRequired")) +
                    "\n        "
                ),
              ]
            ),
            _c(
              "yxt-button",
              {
                staticClass: "mt16",
                attrs: { type: "primary", loading: _vm.btnDisabled },
                on: { click: _vm.downloadExcel },
              },
              [
                _vm._v(
                  "\n          " +
                    _vm._s(_vm.$t("pc_gwnl_import_download")) +
                    "\n        "
                ),
              ]
            ),
          ],
          1
        ),
        _c("li", [
          _c("span", { staticClass: "yxt-upload-explain-num color-gray-8" }, [
            _vm._v("3"),
          ]),
          _c(
            "div",
            {
              staticClass:
                "standard-size-14 color-gray-10 yxt-upload-explain-title",
            },
            [
              _vm._v(
                "\n          " +
                  _vm._s(_vm.$t("pc_gwnl_import_instruction1")) +
                  "\n        "
              ),
            ]
          ),
          _c(
            "div",
            { staticClass: "yxt-upload-explain-summary color-gray-8" },
            [
              _vm._v(
                "\n          " +
                  _vm._s(_vm.$t("pc_gwnl_import_instruction2")) +
                  "\n        "
              ),
            ]
          ),
        ]),
      ]),
      _vm.step === 1
        ? _c(
            "div",
            { staticClass: "yxt-upload-container" },
            [
              _c(
                "yxtbiz-upload",
                {
                  ref: "bizUpload",
                  attrs: {
                    source: "501",
                    "config-key": "AttachConfigKey",
                    "module-name": "attach",
                    "function-name": "import",
                    "app-code": _vm.module,
                    "before-upload": _vm.beforeUpload,
                    "on-progress": _vm.onProgress,
                    "on-uploaded": _vm.onUploaded,
                    "on-error": _vm.onError,
                    drag: true,
                    filters: ".xlsx,.xls",
                    "files-filter": _vm.filesFilter,
                  },
                },
                [
                  _c("div", { attrs: { slot: "tip" }, slot: "tip" }, [
                    _vm._v(
                      "\n          " +
                        _vm._s(_vm.$t("pc_gwnl_import_supportExtension")) +
                        "\n        "
                    ),
                  ]),
                ]
              ),
            ],
            1
          )
        : _vm._e(),
      _vm.step === 3
        ? _c("div", { staticClass: "yxt-upload-container" }, [
            _c("ul", { staticClass: "yxt-upload-item-list" }, [
              _c(
                "li",
                { staticClass: "is-completed color-primary-6" },
                [
                  _c("span", { staticClass: "yxt-upload-status" }),
                  _c(
                    "yxt-row",
                    {
                      staticClass: "color-gray-10 yxt-upload-item-title",
                      attrs: { type: "flex", align: "middle" },
                    },
                    [
                      _vm._v(
                        "\n            " +
                          _vm._s(_vm.file.name) +
                          "\n            "
                      ),
                      _c(
                        "yxt-button",
                        {
                          attrs: { type: "primary" },
                          on: { click: _vm.reset },
                        },
                        [
                          _vm._v(
                            "\n              " +
                              _vm._s(
                                _vm.successCount > 0 && _vm.failedCount > 0
                                  ? this.$t("cc_btn_continueupload")
                                  : this.$t("pc_gwnl_import_reupload")
                              ) +
                              "\n            "
                          ),
                        ]
                      ),
                    ],
                    1
                  ),
                  _c(
                    "yxt-row",
                    {
                      staticClass: "standard-size-12 lh20 mt4",
                      attrs: { type: "flex", align: "middle" },
                    },
                    [
                      _c(
                        "yxt-link",
                        { attrs: { underline: false, type: "success" } },
                        [_c("i", { staticClass: "yxt-icon-success" })]
                      ),
                      _c("span", { staticClass: "color-gray-8 ml3" }, [
                        _vm._v(_vm._s(_vm.$t("pc_gwnl_import_uploadSuccess"))),
                      ]),
                    ],
                    1
                  ),
                ],
                1
              ),
              _vm.checking
                ? _c(
                    "li",
                    { staticClass: "is-active color-primary-6" },
                    [
                      _c("span", { staticClass: "yxt-upload-status" }),
                      _c(
                        "div",
                        { staticClass: "color-gray-10 yxt-upload-item-title" },
                        [
                          _vm._v(
                            "\n            " +
                              _vm._s(
                                _vm.$t("pc_gwnl_import_msg_checkingFormat")
                              ) +
                              "\n          "
                          ),
                        ]
                      ),
                      _c(
                        "yxt-row",
                        {
                          staticClass: "standard-size-12 lh20 mt4",
                          attrs: { type: "flex", align: "middle" },
                        },
                        [
                          _c("span", { staticClass: "color-gray-8 ml16" }, [
                            _vm._v(_vm._s(_vm.$t("pc_gwnl_import_checking"))),
                          ]),
                        ]
                      ),
                    ],
                    1
                  )
                : _vm._e(),
              _vm.failedCount > 0 && _vm.successCount === 0
                ? _c(
                    "li",
                    { staticClass: "is-active color-primary-6" },
                    [
                      _c("span", { staticClass: "yxt-upload-status" }),
                      _c(
                        "yxt-row",
                        {
                          staticClass: "color-gray-10 yxt-upload-item-title",
                          attrs: { type: "flex", align: "middle" },
                        },
                        [
                          _vm._v(
                            "\n            " +
                              _vm._s(_vm.$t("pc_gwnl_import_abnormalFormat")) +
                              "\n          "
                          ),
                        ]
                      ),
                      _c(
                        "yxt-row",
                        {
                          staticClass: "standard-size-12 lh20 mt4",
                          attrs: { type: "flex", align: "middle" },
                        },
                        [
                          _c(
                            "yxt-link",
                            { attrs: { underline: false, type: "warning" } },
                            [_c("i", { staticClass: "yxt-icon-warning" })]
                          ),
                          _c("span", { staticClass: "color-gray-8 ml3" }, [
                            _vm._v(
                              _vm._s(_vm.$t("pc_gwnl_import_checkFailed"))
                            ),
                          ]),
                          _c(
                            "yxt-link",
                            {
                              staticClass: "standard-size-12 ml8",
                              attrs: { type: "primary", underline: false },
                              on: { click: _vm.downloadError },
                            },
                            [
                              _vm._v(
                                "\n              " +
                                  _vm._s(
                                    _vm.$t("pc_gwnl_import_downloadErrDes")
                                  ) +
                                  "\n            "
                              ),
                            ]
                          ),
                        ],
                        1
                      ),
                    ],
                    1
                  )
                : _vm._e(),
              _vm.showError
                ? _c(
                    "li",
                    { staticClass: "is-active color-primary-6" },
                    [
                      _c("span", { staticClass: "yxt-upload-status" }),
                      _c(
                        "yxt-row",
                        {
                          staticClass: "color-gray-10 yxt-upload-item-title",
                          attrs: { type: "flex", align: "middle" },
                        },
                        [
                          _vm._v(
                            "\n            " +
                              _vm._s(_vm.$t("pc_gwnl_import_selectAgain")) +
                              "\n          "
                          ),
                        ]
                      ),
                      _c(
                        "yxt-row",
                        {
                          staticClass: "standard-size-12 lh20 mt4",
                          attrs: { type: "flex", align: "middle" },
                        },
                        [
                          _c(
                            "yxt-link",
                            { attrs: { underline: false, type: "danger" } },
                            [_c("i", { staticClass: "yxt-icon-error" })]
                          ),
                          _c("span", { staticClass: "color-gray-8 ml3" }, [
                            _vm._v(
                              _vm._s(
                                _vm.errorMsg ||
                                  _vm.$t("pc_gwnl_import_checkFail")
                              )
                            ),
                          ]),
                        ],
                        1
                      ),
                    ],
                    1
                  )
                : _vm._e(),
              !_vm.checking && _vm.successCount > 0
                ? _c(
                    "li",
                    { staticClass: "is-completed color-primary-6" },
                    [
                      _c("span", { staticClass: "yxt-upload-status" }),
                      _c(
                        "yxt-row",
                        {
                          staticClass: "color-gray-10 yxt-upload-item-title",
                          attrs: { type: "flex", align: "middle" },
                        },
                        [
                          _vm._v(
                            "\n            " +
                              _vm._s(_vm.$t("pc_gwnl_import_checkCompleted")) +
                              "\n          "
                          ),
                        ]
                      ),
                      _c(
                        "yxt-row",
                        {
                          staticClass: "standard-size-12 lh20 mt4",
                          attrs: { type: "flex", align: "middle" },
                        },
                        [
                          _c(
                            "yxt-link",
                            { attrs: { underline: false, type: "success" } },
                            [_c("i", { staticClass: "yxt-icon-success" })]
                          ),
                          _c("span", { staticClass: "color-gray-8 ml3" }, [
                            _vm._v(
                              _vm._s(_vm.$t("pc_gwnl_import_checkPassed"))
                            ),
                          ]),
                        ],
                        1
                      ),
                    ],
                    1
                  )
                : _vm._e(),
              _vm.successCount > 0 && _vm.failedCount === 0
                ? _c(
                    "li",
                    { staticClass: "is-active color-primary-6" },
                    [
                      _c("span", { staticClass: "yxt-upload-status" }),
                      _c(
                        "yxt-row",
                        {
                          staticClass: "color-gray-10 yxt-upload-item-title",
                          attrs: { type: "flex", align: "middle" },
                        },
                        [
                          _vm._v(
                            "\n            " +
                              _vm._s(
                                _vm.$t("pc_gwnl_import_importSuccessCount1")
                              ) +
                              "\n            "
                          ),
                          _c(
                            "yxt-link",
                            {
                              staticClass: "standard-size-14",
                              attrs: { underline: false, type: "success" },
                            },
                            [
                              _vm._v(
                                "\n              " +
                                  _vm._s(_vm.successCount) +
                                  "\n            "
                              ),
                            ]
                          ),
                          _vm._v(
                            "\n            " +
                              _vm._s(
                                _vm.$t("pc_gwnl_import_importSuccessCount2")
                              ) +
                              "\n          "
                          ),
                        ],
                        1
                      ),
                      _c(
                        "yxt-row",
                        {
                          staticClass: "standard-size-12 lh20 mt4",
                          attrs: { type: "flex", align: "middle" },
                        },
                        [
                          _c(
                            "yxt-link",
                            { attrs: { underline: false, type: "success" } },
                            [_c("i", { staticClass: "yxt-icon-success" })]
                          ),
                          _c("span", { staticClass: "color-gray-8 ml3" }, [
                            _vm._v(
                              _vm._s(_vm.$t("pc_gwnl_import_importSuccess"))
                            ),
                          ]),
                        ],
                        1
                      ),
                    ],
                    1
                  )
                : _vm._e(),
              _vm.successCount > 0 && _vm.failedCount > 0
                ? _c(
                    "li",
                    { staticClass: "is-active color-primary-6" },
                    [
                      _c("span", { staticClass: "yxt-upload-status" }),
                      _c(
                        "yxt-row",
                        {
                          staticClass: "color-gray-10 yxt-upload-item-title",
                          attrs: { type: "flex", align: "middle" },
                        },
                        [
                          _c(
                            "yxt-link",
                            {
                              staticClass: "standard-size-14",
                              attrs: { underline: false, type: "success" },
                            },
                            [
                              _vm._v(
                                "\n              " +
                                  _vm._s(_vm.successCount) +
                                  "\n            "
                              ),
                            ]
                          ),
                          _vm._v(
                            "\n            " +
                              _vm._s(
                                _vm.$t("pc_gwnl_import_importSuccessFailed1")
                              ) +
                              "\n            "
                          ),
                          _c(
                            "yxt-link",
                            {
                              staticClass: "standard-size-14",
                              attrs: { underline: false, type: "danger" },
                            },
                            [
                              _vm._v(
                                "\n              " +
                                  _vm._s(_vm.failedCount) +
                                  "\n            "
                              ),
                            ]
                          ),
                          _vm._v(
                            "\n            " +
                              _vm._s(
                                _vm.$t("pc_gwnl_import_importSuccessFailed2")
                              ) +
                              "\n          "
                          ),
                        ],
                        1
                      ),
                      _c(
                        "yxt-row",
                        {
                          staticClass: "standard-size-12 lh20 mt4",
                          attrs: { type: "flex", align: "middle" },
                        },
                        [
                          _c(
                            "yxt-link",
                            { attrs: { underline: false, type: "success" } },
                            [_c("i", { staticClass: "yxt-icon-success" })]
                          ),
                          _c("span", { staticClass: "color-gray-8 ml3" }, [
                            _vm._v(
                              _vm._s(_vm.$t("pc_gwnl_import_importCompleted"))
                            ),
                          ]),
                          _c(
                            "yxt-link",
                            {
                              staticClass: "standard-size-12 ml8",
                              attrs: { type: "primary", underline: false },
                              on: { click: _vm.downloadError },
                            },
                            [
                              _vm._v(
                                "\n              " +
                                  _vm._s(
                                    _vm.$t(
                                      "pc_gwnl_import_btn_downloadfaileddata"
                                    )
                                  ) +
                                  "\n            "
                              ),
                            ]
                          ),
                        ],
                        1
                      ),
                    ],
                    1
                  )
                : _vm._e(),
              _vm.successCount === 0
                ? _c("li", { staticClass: "color-primary-6" }, [
                    _c("span", { staticClass: "yxt-upload-status" }),
                    _c(
                      "div",
                      { staticClass: "color-gray-8 yxt-upload-item-title" },
                      [
                        _vm._v(
                          "\n            " +
                            _vm._s(_vm.$t("pc_gwnl_import_downloadData")) +
                            "\n          "
                        ),
                      ]
                    ),
                  ])
                : _vm._e(),
            ]),
          ])
        : _vm._e(),
    ]),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }